import { useId, type CSSProperties, type ReactNode, type Ref } from 'react';

/** {@link Panel} のプロパティ。 */
export interface PanelProps {
  /** 見出し */
  readonly title: string;
  readonly children?: ReactNode;
  readonly className?: string;
  /** 見出しの横に置く操作（閉じる・動かすなど） */
  readonly actions?: ReactNode;
  readonly style?: CSSProperties | undefined;
  readonly ref?: Ref<HTMLElement>;
  readonly 'data-testid'?: string;
}

/** 見出し付きのパネル。見出しをランドマークの名前として使う。 */
export function Panel({
  title,
  children,
  className,
  actions,
  style,
  ref,
  'data-testid': testId,
}: PanelProps) {
  const headingId = useId();
  const heading = (
    <h2 id={headingId} className="rcs-panel__title">
      {title}
    </h2>
  );
  return (
    <section
      ref={ref}
      className={['rcs-panel', className ?? ''].filter(Boolean).join(' ')}
      aria-labelledby={headingId}
      style={style}
      data-testid={testId}
    >
      {actions === undefined ? (
        heading
      ) : (
        <div className="rcs-panel__header">
          {heading}
          <div className="rcs-panel__actions">{actions}</div>
        </div>
      )}
      <div className="rcs-panel__body">{children}</div>
    </section>
  );
}
